import React from "react";
import { AiOutlineCheck } from "react-icons/ai";

const PreferenceTile = ({
  data,
  activeChoosingPlan,
  optionNumber,
  onClick,
}: {
  data: any;
  activeChoosingPlan: number | null;
  optionNumber: number;
  onClick: () => void;
}) => {
  const isActive = activeChoosingPlan === optionNumber;
  return (
    <div
      style={{
        border: "2px solid #D3E1F0",
        padding: "24px 16px",
        display: "flex",
        marginTop: "24px",
        boxShadow: "0px 6px 6px rgba(0, 0, 0, 0.1)",
        alignItems: "center",
        borderColor: isActive ? "#0065F2" : "#D3E1F0",
      }}
      onClick={onClick}
    >
      <div>
        <div
          className={`step ${isActive ? "active" : ""}`}
          style={{ borderColor: "#0065F2" }}
        >
          {isActive && <AiOutlineCheck size={25} />}
        </div>
      </div>
      <div style={{ paddingLeft: 32 }}>
        {data.title && (
          <h2
            style={{
              fontSize: "30px",
              lineHeight: "36px",
              fontWeight: "600",
              color: "#003A5D",
              textTransform: "uppercase",
            }}
          >
            {data.title}
          </h2>
        )}

        <p style={{ fontSize: "25px", lineHeight: "32px" }}>{data.info}</p>
      </div>
    </div>
  );
};

export default PreferenceTile;
